/**
 * reCAPTCHA v3 (GORUNMEZ) — istemci tarafi
 *
 * ================================================================
 * SCRIPT YALNIZCA YAPILANDIRILMISSA YUKLENIYOR
 * ================================================================
 * Site anahtari yoksa Google'a hicbir istek gitmiyor. Kosulsuz
 * yuklemek, koruma acilmadan once bile her ziyaretcinin verisini
 * ucuncu tarafa gondermek olurdu — KVKK acisindan savunulamaz ve
 * gereksiz.
 *
 * Ayni sebeple script bir kez yuklendikten sonra kaldirilmiyor:
 * kaldirmak sayfayi yenilemeden mumkun degil ve yarim kaldirma
 * `grecaptcha` nesnesini bozuk birakir.
 */

/** Sunucudakiyle AYNI sabit; ayrisirsa jeton "yanlis eylem" sayilir. */
export const RECAPTCHA_EYLEMI = "panel_giris";

interface Grecaptcha {
  ready: (cb: () => void) => void;
  execute: (siteAnahtari: string, secenekler: { action: string }) => Promise<string>;
}

declare global {
  interface Window {
    grecaptcha?: Grecaptcha;
  }
}

let yuklemeSozu: Promise<void> | null = null;

function scriptYukle(siteAnahtari: string): Promise<void> {
  // Ayni anda iki cagri gelirse TEK script yukleniyor. Ikisi de kendi
  // etiketini eklerse `grecaptcha` iki kez tanimlanir ve v3 sessizce
  // calismayi birakir.
  if (yuklemeSozu) return yuklemeSozu;

  yuklemeSozu = new Promise<void>((coz, red) => {
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteAnahtari)}`;
    s.async = true;
    s.onload = () => coz();
    s.onerror = () => {
      // Bir sonraki denemenin yeniden yuklemesine izin ver.
      yuklemeSozu = null;
      red(new Error("reCAPTCHA yüklenemedi"));
    };
    document.head.appendChild(s);
  });

  return yuklemeSozu;
}

/**
 * Giris icin jeton uretir.
 *
 * ================================================================
 * HATA GIRISI ENGELLEMIYOR
 * ================================================================
 * `null` donuyor ve giris istegi jetonsuz gidiyor. Karari SUNUCU
 * veriyor: entegrasyon aktifse jetonsuz istek zaten reddedilecek,
 * degilse zaten gerekmiyordu.
 *
 * Istemcinin "jeton alamadim, gondermeyeyim" demesi yanlis olurdu:
 * reklam engelleyici yuzunden script yuklenemeyen mesru bir kullanici
 * sonsuza kadar giris ekraninda kalirdi ve sebebini goremezdi.
 */
export async function girisJetonu(siteAnahtari: string | null): Promise<string | null> {
  if (!siteAnahtari) return null;

  try {
    await scriptYukle(siteAnahtari);
    const g = window.grecaptcha;
    if (!g) return null;

    await new Promise<void>((coz) => g.ready(coz));
    return await g.execute(siteAnahtari, { action: RECAPTCHA_EYLEMI });
  } catch {
    return null;
  }
}

export interface RecaptchaDurumu {
  siteAnahtari: string | null;
  aktif: boolean;
  esik: number;
}

/**
 * ETKINLESTIRME ICIN DENEME JETONU — 08.08.2026.
 *
 * `girisJetonu`dan iki farki var:
 *
 *   1. Hatayi YUTMUYOR, firlatiyor. Girisi engellememek icin orada
 *      sessiz kalmak dogruydu; burada tam tersi — jeton uretilemiyorsa
 *      koruma ACILMAMALI ve sebebi soylenmeli.
 *   2. Onbelleklenmis script'i kullanmiyor. Yonetici yeni bir site
 *      anahtari yaziyorsa, ESKI anahtarla yuklenmis `grecaptcha`
 *      nesnesi yeni anahtarin gecerli oldugunu "kanitlar" ve yanlis
 *      anahtarla koruma acilirdi.
 */
export async function denemeJetonu(siteAnahtari: string): Promise<string> {
  const s = document.createElement("script");
  s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteAnahtari)}`;
  s.async = true;

  await new Promise<void>((coz, red) => {
    s.onload = () => coz();
    s.onerror = () => red(new Error("reCAPTCHA yüklenemedi — site anahtarı yanlış olabilir."));
    document.head.appendChild(s);
  });

  const g = window.grecaptcha;
  if (!g) throw new Error("reCAPTCHA yüklendi ama çalışmadı.");

  await new Promise<void>((coz) => g.ready(coz));
  const jeton = await g.execute(siteAnahtari, { action: RECAPTCHA_EYLEMI });
  if (!jeton) throw new Error("reCAPTCHA jeton üretmedi — site anahtarı yanlış olabilir.");
  return jeton;
}
